import React, { useContext } from 'react';
import { useLabels, useRequestData } from 'wsm-common-data';
import { trackEvent } from 'ddc-track-event';
import { IncentivesContext, FiltersContext, UIContext } from '../contexts';
import { clearAllEvent } from '../utils/wueTracking';
import FacetGroup from './FacetGroup';
import ActiveFilterChips from './ActiveFilterChips';

const FacetGroupsSection = () => {
	const { incentives } = useContext(IncentivesContext);
	const { activeFilters, clearAll } = useContext(FiltersContext);
	const { isMobile } = useContext(UIContext);
	const labels = useLabels();
	const { widgetName, windowId } = useRequestData();

	const byVehicle = incentives?.byVehicle || {};
	const allMakes = [
		...new Set(
			Object.values(byVehicle)
				.map((v) => v.make?.toLowerCase())
				.filter(Boolean)
		)
	];
	const showMake = allMakes.length > 1;

	const hasActiveFilters = Object.values(activeFilters).some(
		(arr) => arr.length > 0
	);

	const clearLabel = labels.get('INCENTIVES_CLEAR_FILTERS');

	return (
		<div className="facet-groups-section">
			{isMobile && (
				<div className="d-flex align-items-center justify-content-between py-3">
					<ActiveFilterChips />
					{hasActiveFilters && (
						<button
							type="button"
							className="btn btn-link ddc-font-size-small p-0 text-nowrap"
							onClick={() => {
								trackEvent(
									widgetName,
									windowId,
									clearAllEvent({ label: clearLabel })
								);
								clearAll();
							}}
						>
							{clearLabel}
						</button>
					)}
				</div>
			)}
			{!isMobile && (
				<div className="facet-groups-section__header py-4 m-0 border-bottom">
					<h2 className="facet-groups-section__title">
						{labels.get('INCENTIVES_FILTER_BY')}
					</h2>
				</div>
			)}
			<FacetGroup facetKey="offerTypes" />
			<FacetGroup facetKey="year" />
			<FacetGroup facetKey="bodyStyle" />
			{showMake && <FacetGroup facetKey="make" />}
			<FacetGroup facetKey="model" />
		</div>
	);
};

export default FacetGroupsSection;
